(ns minorodata.analytics-models.subs
  (:require [minorodata.utils :as utils]
            [re-frame.core :as re-frame]))


(re-frame/reg-sub
 :analytics-models.subs/registry-model
 (fn [[_ project-name]]
   (re-frame/subscribe [:analytics-model-registry/pull
                        [:analytics-model-registry/project-name project-name]]))
 (fn [registry-model _]
   registry-model))


(re-frame/reg-sub
 :analytics-models.subs/models-grouped
 :<- [:analytics-model-registry/pull-many]
 :<- [:analytics-model/pull-many]
 (fn [[registry-models models]]
   (->> models
        (group-by (juxt :analytics-model/registry-model
                        :analytics-model/version-label))
        (map (fn [[[project-name version] items]]
               {:project-name project-name
                :display-name (some-> (utils/find-by-field registry-models :analytics-model-registry/project-name project-name)
                                      :analytics-model-registry/display-name)
                :version      version
                :items        (sort-by :analytics-model/name items)}))
        (sort-by :display-name))))


(re-frame/reg-sub
 :analytics-models.subs/model
 (fn [[_ id]]
   (re-frame/subscribe [:analytics-model/pull [:analytics-model/model-id id]]))
 (fn [model _]
   model))


;; Last-run status for a single instance. Returns nil when the model has never run
;; (nothing to render but a "not yet run" pill). Statuses are raw wire maps, so keys
;; are plain kebab-case.
(re-frame/reg-sub
 :analytics-models.subs/last-run-status
 (fn [[_ id]]
   (re-frame/subscribe [:statuses.subs/entity :model id]))
 (fn [status _]
   status))


(defn version-status
  "Classify an instance's pinned build against the latest registry build.
   Returns nil when the instance is up to date (or there isn't enough data to
   tell), else a map describing the difference:

     {:change-type :version   ; a wholly new version exists — re-create needed
      :current {:version ...}
      :latest  {:version ...}}

     {:change-type :revision  ; same version, newer image — up-versionable
      :current {:version .. :task-definition ..}
      :latest  {:version .. :task-definition ..}}

   A `:version` change takes precedence: a newer version may carry schema/UI
   drift, so we never offer in-place up-version for it."
  [instance registry]
  (let [pinned-version  (:analytics-model/version-label instance)
        latest-version  (:analytics-model-registry/version registry)
        pinned-task-def (:analytics-model/task-definition instance)
        latest-task-def (:analytics-model-registry/task-definition registry)]
    (cond
      (or (nil? pinned-version) (nil? latest-version))
      nil

      (not= pinned-version latest-version)
      {:change-type :version
       :current     {:version pinned-version}
       :latest      {:version latest-version}}

      (and pinned-task-def latest-task-def (not= pinned-task-def latest-task-def))
      {:change-type :revision
       :current     {:version pinned-version :task-definition pinned-task-def}
       :latest      {:version latest-version :task-definition latest-task-def}}

      :else nil)))


;; Out-of-date status for a single instance. Joins the instance against the
;; registry catalogue (already hydrated with the latest build per model name)
;; rather than firing its own request, so it recomputes whenever a fresh
;; latest-version lands in the store.
(re-frame/reg-sub
 :analytics-models.subs/version-status
 :<- [:analytics-model/pull-many]
 :<- [:analytics-model-registry/pull-many]
 (fn [[instances registry-models] [_ id]]
   (let [instance (utils/find-by-field instances
                                       :analytics-model/model-id id)
         registry (utils/find-by-field registry-models
                                       :analytics-model-registry/project-name
                                       (:analytics-model/registry-model instance))]
     (version-status instance registry))))
